var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"w-100 o-25"})
}
var staticRenderFns = []

export { render, staticRenderFns }